(() => {
  const configElement = document.getElementById('heimat-posthog-config');
  if (!configElement || window.Shopify?.designMode || window.posthog) return;
  const config = JSON.parse(configElement.textContent);
  if (!/^phc_[a-zA-Z0-9]+$/.test(config.key)) return;
  // Restrict tracking to public browsing surfaces, including localized routes.
  const path = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
  if (path !== '/' && !/^\/(products|collections|blogs)(\/|$)/.test(path)) return;
  if (window.location.search.includes('preview_theme_id')) return;
  const host = config.region === 'us' ? 'https://us.i.posthog.com' : 'https://eu.i.posthog.com';
  let started = false;
  let ready = false;
  let active = false;

  function consentAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.currentVisitorConsent().analytics === 'yes' && privacy.analyticsProcessingAllowed();
  }

  function cleanURL(value) {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin + url.pathname;
    } catch {
      return '';
    }
  }

  function beforeSend(event) {
    if (!consentAllowed()) return null;
    // Replays are excluded on URLs with parameters; never rewrite recorder payloads.
    if (event.event === '$snapshot') return config.replay && !window.location.search ? event : null;
    for (const key of Object.keys(event.properties || {})) {
      if (/url|referrer/i.test(key)) event.properties[key] = cleanURL(event.properties[key]);
      if (/utm_|initial_utm_|title|search|gclid|fbclid/i.test(key)) delete event.properties[key];
    }
    return event;
  }

  function syncConsent() {
    const allowed = consentAllowed();
    if (allowed && !started) {
      started = true;
      installSDK();
      window.posthog.init(config.key, {
        api_host: host,
        defaults: '2026-05-30',
        person_profiles: 'never',
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
        capture_dead_clicks: false,
        capture_heatmaps: false,
        capture_exceptions: false,
        capture_performance: false,
        disable_surveys: true,
        enable_recording_console_log: false,
        opt_out_capturing_by_default: true,
        opt_out_persistence_by_default: true,
        disable_session_recording: true,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '*',
          blockSelector: 'form, iframe, [contenteditable], .ph-no-capture',
          recordCrossOriginIframes: false,
          recordHeaders: false,
          recordBody: false,
          recordPerformance: false,
          recordCanvas: false,
          maskCapturedNetworkRequestFn: () => null
        },
        before_send: beforeSend,
        loaded: () => {
          ready = true;
          syncConsent();
        }
      });
    }
    if (!ready || allowed === active) return;
    active = allowed;
    if (allowed) {
      window.posthog.opt_in_capturing({ captureEventName: null });
      window.posthog.capture('$pageview', { $current_url: cleanURL(window.location.href) });
      if (config.replay && !window.location.search) {
        window.posthog.set_config({ disable_session_recording: false });
        window.posthog.startSessionRecording();
      }
    } else {
      window.posthog.stopSessionRecording();
      window.posthog.set_config({ disable_session_recording: true });
      window.posthog.opt_out_capturing();
    }
  }

  function installSDK() {
    // Official PostHog bootstrap, retrieved from the JavaScript installation docs.
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) syncConsent();
    });
  }
})();
